import { SegmentType } from '@/player-config/src/types/Segment/Type';
import { CompositionConfig } from '@/player-config/src/types/RemotionPlayerConfigTypes/CompositionConfig';
import { VideoSegment } from '@/player-config/src/types/RemotionPlayerConfigTypes/Segment/VideoSegment';
import { getSegmentsTrack } from '@/player-config/src/utils/playerConfigGetters';

export const getVideoSegmentById = (playerConfig: CompositionConfig, id: string): VideoSegment | undefined => {
  const segmentsTrack = getSegmentsTrack(playerConfig);
  return segmentsTrack?.segments?.find(segment => segment.type === SegmentType.VIDEO && segment.id === id) as
    | VideoSegment
    | undefined;
};
